var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "820px",
    viewBox: "0 0 1440 820",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.43013734%",
    y1: "-17.6243013%",
    x2: "50%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.01,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.02,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "66.8719014%",
    y2: "87.9838784%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.01,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.04,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.4260833%",
    y1: "44.3123794%",
    x2: "75.0463678%",
    y2: "65.2398003%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.02,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "77.6224786%",
    y1: "34.4188974%",
    x2: "61.2142769%",
    y2: "56.4009385%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.05,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.01,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.34707908%",
    y1: "42.8813389%",
    x2: "87.1825875%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.02,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.03,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Signin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Username-FILLED-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    fill: "url(#linearGradient-1)",
    points: "1.84741111e-13 474 473 2.13162821e-14 1.84741111e-13 2.13162821e-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    fill: "url(#linearGradient-2)",
    points: "1385 820 1347 515 1440 515 1440 820"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    fill: "url(#linearGradient-3)",
    points: "1440 25 0 635 0 647 429 820 1440 820"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "1440 696 0 310 0 141 185 0 1440 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    fill: "url(#linearGradient-5)",
    points: "796.210203 820 0.210203261 820 0.210203261 0 177.210203 0"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.5d37529d9c1911edd3df9b274733cd95.svg";
export { ForwardRef as ReactComponent };